import Model from "./Model";
import Treatment from './Treatment';
import AgeGroup from '../enums/AgeGroup';
import ToothType from '../enums/ToothType';
import ToothPosition from '../enums/ToothPosition';
import ToothLocation from '../enums/ToothLocation';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";

class Tooth extends Model {
    id: number;
    number: string;
    type: ToothType;
    position: ToothPosition;
    location: ToothLocation;
    age_group: AgeGroup;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Tooth';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Treatment)
    treatments: Treatment[];


    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    // ...

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Tooth[];
    static new(plain: {}, options?: ClassTransformOptions): Tooth;
    static new(plain: {} | [], options?: ClassTransformOptions): Tooth | Tooth[] {
        return plainToClass(Tooth, plain as any, options);
    }

}

export default Tooth;
